<template>

    <div class="tiny-progressbar-cont">
        <div class="bar-cont">
            <div class="prog-bar" ref="outer">
                <div class="bar bar-outer">
                    <div class="bar bar-inner" ref="progbar" :style="{width: progressStr}"></div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    export default {
        name: 'TinyProgressBar',
        props: ['me', 'post'],
        data() {
            return {
                progress: 0
            }
        },
        computed:{
            progressStr(){
                return this.progress+"%"
            }
        },
        mounted() {
            this.$bus.$on('player.progress', (data) => {
              this.progress = data.progress;
            })
        }

    }
</script>

<style lang="sass" scoped>

    @import '../../assets/sass/vars.scss'

    .tiny-progressbar-cont
        display: table
        width: 100%
        position: absolute
        bottom: 0
        left: 0

        .bar-inner
          height: 2px
          background-color: $colorPrimary


    .bar-cont, .time-cont
        display: table-cell




</style>



// WEBPACK FOOTER //
// src/components/player/TinyProgressBar.vue